import FormTextInput from 'components/forms/elements/FormTextInput'

import { NO_PASTE_PROPS } from '../utils/pasteProps'

const emergencyContact = ({ isOnsiteRegistration, formDisabled }) => [
  {
    id: 'emergencyContactName',
    size: { sm: 12, md: !isOnsiteRegistration ? 12 : 6 },
    field: (
      <FormTextInput
        name="emergencyContactName"
        label="Emergency Contact Name"
        required
        autoComplete="new-emergencyContactName"
        disabled={formDisabled}
      />
    ),
  },
  {
    id: 'emergencyContactPhone',
    size: { sm: 12, md: 6 },
    field: (
      <FormTextInput
        name="emergencyContactPhone"
        label="Emergency Contact Number"
        required
        autoComplete="new-emergencyContactPhone"
        disabled={formDisabled}
        {...NO_PASTE_PROPS}
      />
    ),
  },
  {
    ...(!isOnsiteRegistration && {
      id: 'confirmEmergencyContactPhone',
      size: { sm: 12, md: 6 },
      field: (
        <FormTextInput
          name="confirmEmergencyContactPhone"
          label="Confirm Emergency Contact Number"
          required
          autoComplete="new-confirmEmergencyContactPhone"
          disabled={formDisabled}
          {...NO_PASTE_PROPS}
        />
      ),
    }),
  },
]

export default emergencyContact
